module.exports = __webpack_public_path__ + "img/andreas-dress-1406323-unsplash.857330a5.jpg";